// extracted by mini-css-extract-plugin
export default {"container":"WorkTimeManagment_container__HqMNr","sectionTitle":"WorkTimeManagment_sectionTitle__evfhs"};